"use client";

import { parentScrollToTheTop } from "@hudson/ui/lib/utils";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

export default function ScrollParentUpOnPageChange() {
  const [parentScroll, setParentScroll] = useState(0);
  const pathname = usePathname();
  const isInitialMount = useRef(true);

  // Scroll parent to top on page change.
  useEffect(() => {
    // Don't scroll on initial mount/load
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    
    if (parentScroll == 0) {
      setParentScroll(1);
      return;
    } else parentScrollToTheTop();
  }, [pathname]);

  return null;
}
